﻿import React from 'react';
import { Position, ResizableDelta, Rnd } from 'react-rnd';
import styled from 'styled-components';
import { Icon } from '../Icon';
import { SUBTITLE } from '../Fonts';
import { IColumn, IOrderStatus } from './Table';
import { TableHeaderCell } from './TableHeaderCell';
import { RESIZE_IMAGE } from '../Svgs';

const Header = styled.div`
    overflow: hidden;
    display: flex;
    flex-direction: row;
    font: ${SUBTITLE};
`

interface ITableHeaderProps {
    /* Table columns */
    columns: IColumn[];

    /* Header ref */
    containerRef: React.Ref<HTMLDivElement>;

    /* Resize Columns on drag */
    resizeColumns: (columnIndex: number, width: number) => void;

    /* Disable column resize handler */
    disableResize?: boolean;

    onReorder?: (col: number) => void;

    orderStatus?: IOrderStatus;
}


export const TableHeader: React.FunctionComponent<ITableHeaderProps> = (props) => {  
    return (
        <Header ref={props.containerRef}>
            {props.columns.map((c, i) =>
                <span key={i} style={{ borderBottom: "2px solid #243744", height:"40px"}}>
                    <React.Fragment>
                        <div style={{width: c.width+20}}>
                            <TableHeaderCell key={i} column={c} reOrder={props.onReorder} orderStatus={props.orderStatus} />
                        </div>
                        {!props.disableResize &&
                            <Rnd className={`header-resize`}
                                disableDragging={true}
                                enableResizing={{
                                    right: true
                                }}
                                minWidth={c.minWidth}
                                onResize={(e: MouseEvent | TouchEvent, dir: `right`, elementRef: HTMLDivElement, delta: ResizableDelta, position: Position): void => {
                                    props.resizeColumns(i, parseInt(elementRef.style.width.replace(`px`, ``)));
                                }}
                                onResizeStop={(e: MouseEvent | TouchEvent, dir: `right`, elementRef: HTMLDivElement, delta: ResizableDelta, position: Position): void => {
                                    props.resizeColumns(i, parseInt(elementRef.style.width.replace(`px`, ``)));
                                }}

                                position={{
                                    x: 10,
                                    y: 0
                                }}
                                resizeHandleComponent={{
                                    right:
                                        <Icon width="18px" height="40px">{RESIZE_IMAGE}</Icon>
                                }}
                                resizeHandleStyles={{
                                    right: {
                                        paddingRight: `-10px`,
                                        right: `0`
                                    }
                                }}
                                size={{
                                    height: 40,
                                    width: c.width
                                }}
                                style={{
                                    cursor: c.disableReOrder ? `default` : `pointer`,
                                    position: `relative`,
                                }}

                                onMouseDown={
                                    props.onReorder === undefined ? () => { } : () => { props.onReorder(c.columnKey);}
                                }
                            />}
                    </React.Fragment>
                </span>
            )}            
        </Header>
    );
}